/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { isEmpty } from '../helper/is-empty.helper';
import { CoreErrorKey } from '../key/core-error.key';
import { ApplicationError } from '../model/application-error.model';
import { ComparatorValidationOptions, validateComparator } from './comparator.validation-predicate';

export function validateLessThan(
  value: any, options: ComparatorValidationOptions | string, context: object
): boolean {
  if (isEmpty(value)) {
    return true;
  }
  if (options === undefined) {
    throw new ApplicationError({
      key: CoreErrorKey.VALIDATION_OPTIONS_MISSING,
      message: 'Validation options missing'
    });
  }
  const comparator = (a: any, b: any) => a < b;
  if (typeof options === 'object') {
    return validateComparator(value, Object.assign({ comparator }, options), context);
  }
  if (typeof options === 'string') {
    return validateComparator(value, { comparator, key: options }, context);
  }
  return validateComparator(value, { comparator, value: options }, context);
}
